export default __webpack_public_path__ + "img/DpMagqPr.7912d6d4.svg";